import React from "react";
import constructor from "../imgs/equilibristaconstruccion.png"



const NoService = () => {



    return (
        <div class="superNoService">
            <div class="noService">
                <img class="logoconstructor" src={constructor} alt="" />

                <h1 class="ups">¡Ups! Esta parte del sitio aun está en construcción</h1>
            </div>
        </div>
    )
}

export default NoService